import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';

@Component({
  selector: 'app-tms-group-detail',
  templateUrl: './tms-group-detail.component.html',
  styleUrls: ['./tms-group-detail.component.scss']
})
export class TmsGroupDetailComponent implements OnInit {

  trainingGroupFieldData: any = {};
  openSnackbar: any;
  errorStatus: any;
  isProcessing = false;

  constructor(public appService: AppService, public router: Router, readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService,) {
    const data: any = router.getCurrentNavigation()?.extras.state;
    this.trainingGroupFieldData = data['trainingGroupFieldData'];
  }

  ngOnInit() {
    this.dynamicLabelCall();
    this.trainingGroupFieldData.updateReason = ''
  }

  allowOnlyAllowedChars(event: KeyboardEvent): void {
    const allowedPattern = /^[a-zA-Z0-9\s\-._()/\\]$/;
    const inputChar = event.key;
    if (!allowedPattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  backToPreviousPage() {
    this.router.navigate(['dashboard/trainingGroups']);
  }
  backToTrainingGroup() {
    this.router.navigate(['/dashboard/trainingGroups']);
  }

  groupNameValue: any;
  groupNameRequiredMsg: any;
  groupNameRequiredMsgDisplayed: any;
  updateReasonDisplayed: any;
  updateValue: any;
  updateRequiredMsg: any;
  fieldValidation(): boolean {
    let isValid = true;

    this.groupNameValue = document.getElementById('groupName') as HTMLInputElement;
    this.groupNameRequiredMsg = document.getElementById('groupName-required-msg') as HTMLInputElement;

    this.updateValue = document.getElementById('update') as HTMLInputElement;
    this.updateRequiredMsg = document.getElementById('update-required-msg') as HTMLInputElement;
    if (this.trainingGroupFieldData.groupName) {
      this.groupNameValue.style.border = 'none';
      this.groupNameRequiredMsg.style.display = 'none';
      this.groupNameRequiredMsgDisplayed = false;
    } else {
      this.groupNameRequiredMsgDisplayed = true;
      this.groupNameValue.style.border = '1px solid red';
      this.groupNameRequiredMsg.style.display = 'block';
      isValid = false;
    }

    if (this.trainingGroupFieldData.updateReason) {
      this.updateValue.style.border = 'none';
      this.updateRequiredMsg.style.display = 'none';
      this.updateReasonDisplayed = false;
    } else {
      this.updateReasonDisplayed = true;
      this.updateValue.style.border = '1px solid red';
      this.updateRequiredMsg.style.display = 'block';
      isValid = false;
    }

    return isValid;
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  updateTrainingGroup(trainingGroupFieldData: any) {
    // 1. Validation Check
    if (!this.fieldValidation()) {
      return;
    }

    this.isProcessing = true;

    // 2. Prepare Data (Avoid mutating the original argument if possible)
    // We use the spread operator (...) to create a clean object for the API call
    const data = {
      ...trainingGroupFieldData,
      ccReminderEmailToRm: trainingGroupFieldData.ccReminderEmailToRm ? 'Y' : 'N',
      ccEmailToRm: trainingGroupFieldData.ccEmailToRm ? 'Y' : 'N',
      isActive: trainingGroupFieldData.isActive ? 'Y' : 'N',
    };

    // Remove fields not needed for the update API
    delete data.createdOn;
    delete data.updatedOn;

    this.appService.updateTmsGroup(data).subscribe({
      next: (response: any) => {
        this.isProcessing = false;
        const isSuccess = response.resultType === 'S';
         if (isSuccess) {
          this.trainingGroupFieldData.updateReason = ''; 
        }
        const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: isSuccess ? 5000 : undefined,
          data: {
            message: response.result,
            type: isSuccess ? 'Success' : 'Error',
            buttonLabel: "Ok",
            pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: isSuccess ? 'Success' : 'Error',
        });

        sb.onAction().subscribe(() => sb.dismiss());
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  isShowTrainingsGrid = false;
  onTabChanged($event: any) {
    let data = $event.tab.textLabel;
    if (data == "Trainings") {
      this.isShowTrainingsGrid = true;
    }
  }

  dynamicLabel: any = null;
  label: any = [];

  dynamicLabelCall() {
    this.isProcessing = true;
    const data = {
      tableName: 'TMS_GROUPS_VW',
      moduleName: null,
      gridName: 'TRAINING_GROUP',
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (response: any) => {
        this.label = response;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[user.columnName] = user.changedFieldName;
          return acc;
        }, {});

        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
        console.error(error);
      }
    });
  }
}
